import styled, { css } from 'styled-components'

export const PrintModeWrapper = styled.div<{ $printMode?: boolean }>`
  ${({ $printMode }) =>
    $printMode &&
    css`
      /* Tighter padding for print mode */
      padding: 0;

      /* Hide interactive elements */
      .action-buttons,
      .close-button,
      .resize-handle,
      .map-controls,
      .mapboxgl-ctrl-group,
      .mapboxgl-ctrl-attrib,
      .mapboxgl-ctrl-logo {
        display: none !important;
      }

      /* Tighter spacing for sections */
      section {
        margin-bottom: 12px;
        break-inside: avoid;
        page-break-inside: avoid;
      }

      /* Reduce padding in content areas */
      > div {
        padding: 12px 16px;
      }

      /* Smaller map in print mode */
      [class*='MapContainer'] {
        height: 120px;
        min-height: 120px;
      }

      /* Prevent page breaks inside content sections */
      [class*='DataGroup'],
      [class*='ParticipantGroup'],
      [class*='PropertyCard'],
      [class*='TransactionInfoSection'],
      [class*='DescriptionBox'] {
        break-inside: avoid;
        page-break-inside: avoid;
      }
    `}
`
